import { EMPTY_STRING } from '../../../../constants/common'
import { checkEmailForReply } from '../../Email.utils'
import { getRecipientItemId } from '../EmailRecipientsField.utils'

function getEmail(option, printer) {
  if (!checkEmailForReply(option?.email) && !!printer?.email) {
    return `<${printer?.email || EMPTY_STRING}>`
  }

  return `<${option?.email || EMPTY_STRING}>`
}

export function getTagName(option, printer) {
  return `${option?.fullname || EMPTY_STRING} ${getEmail(option, printer)}`
}

export function isErrorEmail(errorItems, item, printer, errorOptionKeys) {
  if (errorOptionKeys?.has?.(getRecipientItemId(item))) {
    return true
  }

  if (!checkEmailForReply(item?.email) && printer?.email) {
    return errorItems?.includes(printer.email)
  }

  return errorItems?.includes(item.email) || errorItems?.includes(item.value)
}
